import {
  CatalogoSearchParams,
  FilterUIFlags,
} from '../../../../shared/catalogo/type/filter'
import { PAGE_SIZE } from '../../../../shared/catalogo/store/list/types.d'
import { t } from '../../../../common/i18n'

export const NEUMATICOS_CATALOG_KEY = 'neumaticos'

export type NeumaticosFilterValues = {}

export interface FilterNeumaticosSections extends FilterUIFlags {
  marcaExpanded: boolean
  estacionExpanded: boolean
  m_sExpanded: boolean
  reforzadoExpanded: boolean
  marcajeExpanded: boolean
  tipo_antipinchazoExpanded: boolean
  tipoExpanded: boolean
  precioExpanded: boolean
  consumoExpanded: boolean
  lluviaExpanded: boolean
  nivel_ruidoExpanded: boolean
  especificacion_adicionalExpanded: boolean
}

export const initialNeumaticoFilterValues: CatalogoSearchParams<NeumaticosFilterValues> =
  {
    filters: {},
    pagination: {
      page: 1,
      pageSize: PAGE_SIZE,
    },
    order: {
      label: t('resultados_neumaticos.recomendado'),
      value: 'orden.asc',
      field: 'orden',
      direction: 'ASC',
    },
  }

export const initialNeumaticoFilterSections: FilterNeumaticosSections = {
  marcaExpanded: true,
  estacionExpanded: true,
  m_sExpanded: true,
  reforzadoExpanded: true,
  marcajeExpanded: true,
  tipo_antipinchazoExpanded: true,
  tipoExpanded: true,
  precioExpanded: true,
  consumoExpanded: true,
  lluviaExpanded: true,
  nivel_ruidoExpanded: true,
  especificacion_adicionalExpanded: true,
}
